<div class="flex flex-row justify-start items-center flex-[0_1_auto] box-border">
  <button
    mat-button
    [matMenuTriggerFor]="userMenu"
    class="user-button px-0">
    @if (imiAuthInfo$ | async; as imiAuthInfo) {
      <div class="text-white flex flex-row justify-center items-center">
        <img
          class="avatar"
          [ngSrc]="'images/avatars/profile.jpg'"
          alt
          height="50"
          width="50" />
        <mat-icon
          i18n
          class="s-4 text-white">
          keyboard_arrow_down
        </mat-icon>
      </div>
    }
  </button>

  <mat-menu
    #userMenu="matMenu"
    [overlapTrigger]="false">
    <!-- <button
      mat-menu-item
      [matMenuTriggerFor]="roles">
      <mat-icon>settings</mat-icon>
      <span i18n>Suplantar rol</span>
    </button> -->

    <!-- <button
      mat-menu-item
      class>
      <mat-icon>help</mat-icon>
      <span i18n>Ajuda</span>
    </button> -->
    <mat-divider class="my-2"></mat-divider>
    <button
      mat-menu-item
      (click)="auth.logoutIDP()">
      <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"> </mat-icon>
      <span i18n>Surt</span>
    </button>
  </mat-menu>

  <mat-menu #roles="matMenu">
    <button
      i18n
      mat-menu-item
      (click)="setRole('admin')">
      Administrador
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('manager')">
      Gestió
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('maintenance')">
      Manteniment
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('internet_manager')">
      Gestió Internet
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('general_warnings')">
      Avisos generals
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('editor')">
      Editor
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('autor')">
      Autor
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('translator')">
      Traductor
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('report')">
      Informes
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('query')">
      Consulta
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('public')">
      Públic
    </button>
    <button
      i18n
      mat-menu-item
      (click)="setRole('bulk')">
      Edició massiva
    </button>
  </mat-menu>
</div>
